import type { FeatureFlags } from '@/features/feature-flag/_models/feature-flags';
import type { TFunction } from '@/i18n';
import { FALLBACK_TEXT } from '@/utils';
import type { z } from 'zod';

export const getFeatureFlagsLabel = (
  t: TFunction,
  key: keyof z.infer<typeof FeatureFlags>,
) => {
  switch (key) {
    case 'comment':
      return t('dev-tools.feature-flag.comment');
    case 'sharingGroup':
      return t('dev-tools.feature-flag.sharing-group');
    case 'revisionListener':
      return t('dev-tools.feature-flag.revision-listener');
    case 'sharingProject':
      return t('dev-tools.feature-flag.sharing-project');
    case 'workflow':
      return t('dev-tools.feature-flag.workflow');

    default:
      return FALLBACK_TEXT;
  }
};
